export function RenameFile(file, userName) {
    const fileParts = file.name.split(".");
    const fileType = fileParts.pop();
    const newName = `${userName}__${fileParts.join(".")}.${fileType}`;
    return new File([file], newName, { type: file.type });
  }